export default __webpack_public_path__ + "static/media/cif-fi.d98dcd57.svg";